export const PERCENT = 'percent';
export const DOLLARS = 'dollars';
export type TipBase = typeof PERCENT | typeof DOLLARS;
